import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {delay, lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

export abstract class AbstractApiService<T> {

  constructor(protected http: HttpClient, protected path: string) { }

  protected createCustomHeaders(headers: { [key: string]: string }): HttpHeaders {
    let customHeaders = new HttpHeaders();
    for (const key in headers) {
      if (headers.hasOwnProperty(key)) {
        customHeaders = customHeaders.set(key, headers[key]);
      }
    }
    return customHeaders;
  }

  //MARK:GET
  async getAll(params?:any,endpointURL?:string): Promise<any>{
    let param = new HttpParams({fromObject: params}).toString()
    return lastValueFrom(this.http.get<any>(`${environment.apiUrl}`+(endpointURL ? endpointURL : this.path) + (param ? '?'+param : '') ));
  }


  async getId(id?:any, endpointURL?:string): Promise<Response>{
    return lastValueFrom(this.http.get<Response>(`${environment.apiUrl}`+(endpointURL ? endpointURL : this.path) +'/'+id));
  }

  async get(endpointURL?:string): Promise<Response>{
    return lastValueFrom(this.http.get<Response>(`${environment.apiUrl}`+(endpointURL ? endpointURL : this.path)));
  }


  //MARK:POST

  async post(data: any, endpointURL?:string): Promise<Response> {
    return lastValueFrom(this.http.post<Response>(`${environment.apiUrl}`+(endpointURL ? endpointURL : this.path) , data));
  }


  //POST with form data
  async post_formdata(data: any, endpointURL?:string, params?:any): Promise<Response> {
    let param = new HttpParams({fromObject: params}).toString()
    let body = new FormData();
    for (var key in data) {
      body.append(key, data[key]);

        // if (Array.isArray(data[key])) {
        //   data[key].forEach((item: any) => {
        //     body.append(key, item);
        //   });
        // } else {
        //   body.append(key, data[key]);
        // }

    }


    return lastValueFrom(
      this.http.post<Response>(
        `${environment.apiUrl}`+(endpointURL ? endpointURL : this.path) + (param ? '?'+param : ''),
        body,
        {
          headers: this.createCustomHeaders({
            'Accept': 'application/json',
            // Add any other headers you need here
          })
        }
      ));
  }


  //MARK:PUT
  async putId(id: number | string, data: T, endpointURL?:string): Promise<T> {
    return lastValueFrom(this.http.put<T>(`${environment.apiUrl}`+(endpointURL ? endpointURL : this.path) +'/'+id, data));
  }

  async put_custom(data:any, endpointURL?:string, params?: any,): Promise<T> {
    let param = new HttpParams({fromObject: params}).toString()
    return lastValueFrom(this.http.put<T>(`${environment.apiUrl}`+(endpointURL ? endpointURL : this.path)+ (param ? '?'+param : ''), data));
  }

  //put with form data
  async put_formdata(data: any, endpointURL?:string, params?:any): Promise<Response> {
    let param = new HttpParams({fromObject: params}).toString()
    let body = new FormData();
    for (var key in data) {
      // if (Array.isArray(data[key])) {
      //   data[key].forEach((item: any) => {
      //     body.append(key, item);
      //   });
      // } else {
      //   body.append(key, data[key]);
      // }

      body.append(key, data[key]);


  }

    return lastValueFrom(
      this.http.put<Response>(
        `${environment.apiUrl}`+(endpointURL ? endpointURL : this.path) + (param ? '?'+param : ''),
        body,
        {
          headers: this.createCustomHeaders({
            'Accept': 'application/json',
            // Add any other headers you need here
          })
        }
      ));
  }


  //MARK:DELETE
  async delete(id: number | string, endpointURL?:string): Promise<Response> {
    return lastValueFrom(this.http.delete<Response>(`${environment.apiUrl}`+(endpointURL ? endpointURL : this.path) +'/'+id));
  }

  //MARK:PATCH
  async patch(id: number | string, partialdata: Partial<T>,endpointURL?:string): Promise<T> {
    return lastValueFrom(this.http.patch<T>(`${environment.apiUrl}`+(endpointURL ? endpointURL : this.path) +'/'+id, partialdata));
  }



}
